import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ewmtw9s8vk: FaireBrandEntity = {
  token: "b_ewmtw9s8vk",
  type: "brand",
  name: "petora",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc9928857920f526d79926207638f6163a4fccbb0d4e6e37abc298ada2ba5852.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6c8955c193f6b78537702f73e6b533e416538de6a093c4453fccee701e7dc432.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc9928857920f526d79926207638f6163a4fccbb0d4e6e37abc298ada2ba5852.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6c8955c193f6b78537702f73e6b533e416538de6a093c4453fccee701e7dc432.jpeg",
  location: "Fullerton, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "K-Beauty for your pets\nGentle, cutting-edge skincare and grooming solutions designed for pet wellness.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:45.321Z",
    importedBy: "entity-db-cli",
  },
};
